import { safelyJoinPaths } from '@trarc/pc-shared';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppContainerContext } from '../../../contexts/AppContainerContext';
import { useUpdatePageGroups } from '../../../hooks';
import { SideBarPageGroups } from '../../../types/enums';
import {
  NestedControlledCollapse,
  PageGroupProps,
  StyledButton,
  StyledCameraIcon,
  StyledControlledCollapse,
  StyledHelpIcon,
  StyledNavLink,
} from './GeneralPageGroup.styles';
import { TitleIconRow } from './TitleIconRow';

const HelpPageGroup = ({ isExpanded }: PageGroupProps) => {
  const { t } = useTranslation();

  const [openNestedPageGroups, setOpenNestedPageGroups] = useState(false);
  const { setShowContactModal } = useAppContainerContext();
  const { openPageGroups, updateOpenPageGroups } = useUpdatePageGroups();

  const isHelpCollapseOpen = isExpanded && openPageGroups.includes(SideBarPageGroups.Help);

  return (
    <StyledControlledCollapse
      title={
        <TitleIconRow
          icon={<StyledHelpIcon />}
          title={t('help.title')}
          $isExpanded={isExpanded}
          open={isHelpCollapseOpen}
        />
      }
      onClick={() => updateOpenPageGroups(SideBarPageGroups.Help)}
      open={isHelpCollapseOpen}
      $isExpanded={isExpanded}
    >
      <StyledButton onClick={() => setShowContactModal(true)}>{t('contactUs.label')}</StyledButton>
      <StyledNavLink to={safelyJoinPaths(process.env.REACT_APP_GRAPHQL_URI, 'api', 'help')} target="_blank">
        {t('help.documentation')}
      </StyledNavLink>
      <NestedControlledCollapse
        title={
          <TitleIconRow
            icon={<StyledCameraIcon />}
            title={t('help.videos')}
            $isExpanded={isExpanded}
            open={openNestedPageGroups}
          />
        }
        onClick={() => setOpenNestedPageGroups(!openNestedPageGroups)}
        open={openNestedPageGroups}
        $isExpanded={isExpanded}
        $isCollapseOpened={openNestedPageGroups}
      >
        <StyledNavLink
          to={
            'https://player.vimeo.com/video/906787629?h=292d8f108d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
          }
          target="_blank"
        >
          {t('help.linkTitles.shorthandRoadmapTutorial')}
        </StyledNavLink>
        <StyledNavLink
          to={
            'https://player.vimeo.com/video/906787554?h=551e644fd1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
          }
          target="_blank"
        >
          {t('help.linkTitles.shorthandFTCReview')}
        </StyledNavLink>
      </NestedControlledCollapse>
    </StyledControlledCollapse>
  );
};

export default HelpPageGroup;
